<template>
  <div
    class="vcore_row frp-additional-information"
    id="frp-additional-information"
  >
    <div class="vcore_col--xs--12 form-container_provider-logo">
      <LogoDisplay v-if="logo" :logo-src="logo"></LogoDisplay>
    </div>
    <div class="vcore_col--xs--12">
      <h2 class="form-title" tabindex="-1" v-focus="$parent.lastActivated">
        FRP Additional Address Information
      </h2>
      <div class="form-description">
        Please complete form for the financially responsible party. All fields
        required unless marked optional.
      </div>
    </div>
    <div class="vcore_col--xs--12 address-options_wrapper">
      <label for="differentMailingAddress" class="vcore_checkbox-group">
        <div class="vcore_checkbox">
          <input
            id="differentMailingAddress"
            type="checkbox"
            class="vcore_checkbox-input"
            v-model="physicalMailingAddressCheckboxLocal"
          />
          <span class="vcore_checkbox-indicator"></span>
        </div>
        <span class="vcore_checkbox-label"
          >Mailing address is different than physical address</span
        >
      </label>
      <label for="movedLastTwoYears" class="vcore_checkbox-group">
        <div class="vcore_checkbox">
          <input
            id="movedLastTwoYears"
            type="checkbox"
            class="vcore_checkbox-input"
            v-model="previousAddressCheckboxLocal"
          />
          <span class="vcore_checkbox-indicator"></span>
        </div>
        <span class="vcore_checkbox-label">Moved in the past two years</span>
      </label>
    </div>
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div
        class="vcore_col--xs--12"
        v-show="physicalMailingAddressCheckboxLocal"
      >
        <slot name="mailing" />
      </div>
    </transition>
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div class="vcore_col--xs--12" v-show="previousAddressCheckboxLocal">
        <slot name="previous" />
      </div>
    </transition>
  </div>
</template>

<script>
import MailingAddressForm from "../../forms/MailingAddress.json";
import PreviousAddressForm from "../../forms/PreviousAddress.json";
import LogoDisplay from "../LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "FRPAdditionalInformation",
  components: {
    LogoDisplay,
  },
  data() {
    return {
      mailingAddressFormData: MailingAddressForm,
      mailingAddressFormValues: {},
      previousAddressFormData: PreviousAddressForm,
      previousAddressFormValues: {},
    };
  },
  computed: {
    ...mapGetters([
      "physicalMailingAddressCheckbox",
      "previousAddressCheckbox",
      "selectedProvider",
    ]),
    physicalMailingAddressCheckboxLocal: {
      get() {
        return this.physicalMailingAddressCheckbox;
      },
      set(value) {
        this.setPhysicalMailingAddressCheckbox(value);
      },
    },
    previousAddressCheckboxLocal: {
      get() {
        return this.previousAddressCheckbox;
      },
      set(value) {
        this.setPreviousAddressCheckbox(value);
      },
    },
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.selectedProvider.customBrandingList
      );
    },
  },
  methods: {
    ...mapActions([
      "setPhysicalMailingAddressCheckbox",
      "setPreviousAddressCheckbox",
    ]),
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
  },
};
</script>

<style lang="scss" scoped>
.address-options_wrapper {
  margin-top: 20px;
}

::v-deep h3 {
  font-size: 21px;
  line-height: 25px;
  font-family: "Poppins";
  color: #43454d;
  font-weight: 500;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
